import { Controller } from "@hotwired/stimulus";

// Mirrors Amp::Country.set_iso2_from_name into the browser: when the Name
// select changes, look up its ISO 3166 alpha-2 code from a data-value map
// and reflect it into the ISO 2 input. Preserves an admin-typed override —
// an input event on the code field flags it as user-edited and the sync
// stops overwriting.
//
// Values:
//   codes: { "Nigeria": "NG", "Kenya": "KE", ... }
//
// Targets:
//   name: the <select> for the country name (also decorated with tomselect)
//   iso2: the <input> that receives the derived code
export default class extends Controller {
  static targets = ["name", "iso2"];
  static values  = { codes: Object };

  connect() {
    this.sync();
  }

  onNameChange() {
    this.sync({ force: true });
  }

  onIso2Input() {
    this.iso2Target.dataset.userEdited = "1";
  }

  sync({ force = false } = {}) {
    if (!this.hasNameTarget || !this.hasIso2Target) return;
    const derived = (this.codesValue || {})[this.nameTarget.value];
    if (!derived) return;
    const cur = this.iso2Target.value.trim();
    if (force || !cur || !this.iso2Target.dataset.userEdited) {
      this.iso2Target.value = derived;
    }
  }
}
